import * as React from "react";
import { Box } from "@mui/material";
import { platformProgressTrackSx } from "../tickitPlatformTheme";

export default function PlatformProgress({ value = 0, color = "#46109B", sx = {} }) {
  const pct = Math.min(100, Math.max(0, value));
  return (
    <Box sx={{ ...platformProgressTrackSx, ...sx }}>
      <Box
        sx={{
          width: `${pct}%`,
          height: "100%",
          borderRadius: 99,
          bgcolor: color,
          transition: "width 0.3s ease",
        }}
      />
    </Box>
  );
}
